






















import Vue from "vue";
import iwModal from "@/shared/components/Modal.vue";

export default Vue.extend({
    components: {
        iwModal: iwModal,
    },

    computed: {
        isReactivateModalOpen: function(): boolean {
            return this.$store.getters["ModalModule/isReactivateModalOpen"];
        },

        classifiedLegacyId: function(): string {
            return this.$store.getters["MyClassifiedsModule/getClassifiedToReactivate"].legacyId;
        },

        phoneNumberLink: function(): string {
            const phoneNumber = this.$t("cuca_phone_number") as string;

            /** Transform:
             * `+32.776.289` into `+32776289`
             * `02/123 56 78` into `021235678`
             */
            const digitsAndLeadingPlusSign = phoneNumber.replace(/(?!\+)\D/g, "") as string;

            return `tel:${digitsAndLeadingPlusSign}`;
        },
    },

    methods: {
        closeReactivateModal: function() {
            this.$store.commit("ModalModule/closeReactivateModal");
        },
    }
});

